import { WORK_ORDER_BUNDLE_STATUS } from "constants/index";
import { Button, Card, Chip, Stack, Typography } from "@mui/material";
import { typographyStyles } from "constants/styles";
import type { IMovementWorkOrderBundleDetail } from "types";

interface Props {
  bundle: IMovementWorkOrderBundleDetail;
  editable: boolean;
  busy: boolean;
  operatorId?: number;
  onEdit: () => void;
}

export default function FractionationBundleCard({
  bundle,
  editable,
  busy,
  operatorId,
  onEdit,
}: Props) {
  const taken = bundle.status === WORK_ORDER_BUNDLE_STATUS.IN_PROCESS;
  const mine = bundle.operator_id === operatorId;
  const total = bundle.available.amount + (bundle.not_available?.amount ?? 0);
  return (
    <Card
      variant="outlined"
      sx={{
        p: 2,
        borderLeft: 4,
        borderLeftColor: bundle.completed
          ? "success.main"
          : taken
            ? "info.main"
            : "warning.main",
      }}
    >
      <Stack spacing={1}>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography sx={typographyStyles.monospace}>
            F-{bundle.lote_externo}
          </Typography>
          <Chip
            size="small"
            label={
              bundle.completed ? "Completo" : taken ? "En trabajo" : "Pendiente"
            }
            color={bundle.completed ? "success" : taken ? "info" : "warning"}
          />
        </Stack>
        <Typography fontWeight={700}>
          {bundle.article.code} · {bundle.article.description}
        </Typography>
        <Typography variant="body2">
          Lote {bundle.lote || bundle.lote_externo} · Ubicación{" "}
          {bundle.destination_location?.code || bundle.location?.code || "Sin ubicación"}
        </Typography>
        <Typography>
          Unidades totales: <strong>{total}</strong>
        </Typography>
        <Typography variant="body2">
          Unidades en paquetes:{" "}
          {bundle.available.packages + (bundle.not_available?.packages ?? 0)} ·
          Sueltos: {bundle.available.loose + (bundle.not_available?.loose ?? 0)}{" "}
          · Scrap: {bundle.available.scrap + (bundle.not_available?.scrap ?? 0)}
        </Typography>
        {bundle.operator && (
          <Typography variant="body2" color="text.secondary">
            {bundle.completed ? "Completado por" : "En trabajo por"}:{" "}
            {bundle.operator.first_name} {bundle.operator.last_name}
          </Typography>
        )}
        {(bundle.completed || (editable && total > 0)) && (
          <Button
            variant="outlined"
            disabled={busy || (!bundle.completed && taken && !mine)}
            onClick={onEdit}
          >
            {bundle.completed
              ? "Consultar fardo"
              : taken
                ? mine
                  ? "Retomar fardo"
                  : "Tomado por otro operario"
                : "Fraccionar"}
          </Button>
        )}
      </Stack>
    </Card>
  );
}
